import { useNarrativeValuationOptions } from '../../../hooks/useNarrativeValuationOptions';
import { useMemo } from 'react';
import { NARRATIVE_FV_MODAL_COMMUNITY_NARRATIVES_LIMIT } from '../../../utils';
import { useMe } from '@/components/User/components/Profile/components/CommunityProfile/hooks/useMe';
import useUser from '@/hooks/useUser';

type Props = {
  companyId: string;
};

export const useValuationSelectionFormData = ({ companyId }: Props) => {
  const { data: user } = useUser();
  const { data } = useMe({}, { enabled: user?.loggedIn });
  const { data: valuationOptionsData } = useNarrativeValuationOptions({
    companyId: companyId.toLowerCase(),
    communityLimit: NARRATIVE_FV_MODAL_COMMUNITY_NARRATIVES_LIMIT,
  });
  const publicId = data?.me?.communityProfile?.publicId;

  return useMemo(() => {
    const { company } = valuationOptionsData ?? {};
    const { valuationOptions, tickerSymbol } = company ?? {};

    const myNarrative =
      valuationOptions?.find(
        (option) =>
          option.type === 'USER_DEFINED' &&
          publicId &&
          option.narrative?.owner?.publicId === publicId
      )?.narrative ?? null;

    return {
      valuationOptions,
      tickerSymbol,
      myNarrative,
    };
  }, [valuationOptionsData, publicId]);
};
